import React, { useEffect } from "react";
import "./HereOutStories.scss";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import YoutubeIcon from "../../images/youtube-red.svg";
import { Fancybox } from "@fancyapps/ui";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import useCityContent from "../../hooks/useCityContent";

const HereOutStories = () => {
  const { cityData } = useCityContent();


  const getYouTubeThumbnail = (url) => {
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^&?/]+)/
    );
    const videoId = match?.[1]?.split("?")[0]; // clean out trailing ?si=...
    return videoId
      ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
      : null;
  };




  useEffect(() => {
    // Bind FancyBox
    Fancybox.bind("[data-fancybox]", {
      Video: {
        autoplay: true,
      },
    });

    // Add FancyBox open event to pause YouTube videos
    document.addEventListener("click", (event) => {
      if (event.target.closest('[data-fancybox="gallery"]')) {
        if (window.pauseYouTubeVideo) {
          window.pauseYouTubeVideo(); // Call the global function to pause YouTube videos
        }
      }
    });

    // Cleanup FancyBox bindings when component unmounts
    return () => Fancybox.destroy();
  }, []);



  return (
    <section className="here-out section-padding-lg">
      <div className="container">
        <div className="here-out__header section-header">
          <h2 dangerouslySetInnerHTML={{ __html: cityData.hear_out_header_title }}>

          </h2>
        </div>

        <div className="here-out__slider">
          <Swiper
            spaceBetween={0}
            slidesPerView={3}
            loop={false}
            speed={1000}
            breakpoints={{
              1500: {
                slidesPerView: 3,
              },
              991: {
                loop: false,
                slidesPerView: 3,
              },
              767: {
                slidesPerView: 2.1,
              },
              600: {
                slidesPerView: 1.5,
              },
              320: {
                slidesPerView: 1.5,
              },
              300: {
                slidesPerView: 1.1,
              },
            }}
          >
            {cityData.hear_out_video.map((item, index) => (
              <SwiperSlide key={index}>
                <div key={index} className="video-iframe-wrapper">
                  <div className="slider__item">
                    <figure>
                      <div className="video-icon">
                        <img src={YoutubeIcon} alt="" />
                      </div>
                      <a
                        href={item.video}
                        data-fancybox="gallery"
                      >
                        <img
                          src={getYouTubeThumbnail(item.video)}
                          alt={`Video Thumbnail ${index + 1}`}
                          className="video-thumbnail"
                        />
                      </a>
                    </figure>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HereOutStories;
